<div class="cr-add-block-gap">
  <label class="cr-gap-control" *ngIf="nextBlock" title="Spacing before the next block in View mode">
    <span>Gap</span>
    <select class="cr-gap-select" [ngModel]="gapSize" (ngModelChange)="onGapSizeChange($event)">
      <option value="20">20px</option>
      <option value="0">0px</option>
    </select>
  </label>

  <button
    type="button"
    class="cr-add-block-trigger"
    [disabled]="addBlockDisabled"
    (click)="onTriggerClick()"
    title="Add block"
  >
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M10 4v12M4 10h12" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
    </svg>
  </button>
</div>
